import {
  AvailableGlobalPermissions,
  AvailablePermissionFlagsValue,
  AvailablePermissionsValue,
  AvailableFlagPermissions,
  RequiredPermissions,
} from 'features/validateAccess';

export const GLOBAL_PROJECT_READ_PERMISSION: RequiredPermissions = [
  [
    {
      type: 'global',
      value: AvailablePermissionsValue.READ,
      global: AvailableGlobalPermissions.PROJECT,
    },
  ],
];

export const GLOBAL_EDIT_ACCOUNT_PERMISSION: RequiredPermissions = [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.ACCOUNT,
      value: AvailablePermissionsValue.UPDATE,
    },
  ],
];

export const getLocalEditAccountPermission = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'local',
      local: accountId,
      global: AvailableGlobalPermissions.ACCOUNT,
      value: AvailablePermissionsValue.UPDATE,
    },
  ],
];

export const getLocalReadProjectPermission = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'subGlobal',
      global: AvailableGlobalPermissions.ACCOUNT,
      parent: accountId,
      subGlobal: AvailableGlobalPermissions.PROJECT,
      value: AvailablePermissionsValue.READ,
    },
  ],
];

export const getAccountViewTimesheetPermission = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableFlagPermissions.TIMESHEET_VIEW,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
    {
      type: 'flagLocal',
      global: AvailableGlobalPermissions.ACCOUNT,
      subFlagGlobal: AvailableFlagPermissions.TIMESHEET_VIEW,
      parent: accountId,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
  ],
];

export const CREATE_ACCOUNT: RequiredPermissions = [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.ACCOUNT,
      value: AvailablePermissionsValue.CREATE,
    },
  ],
];
